import React from 'react'
import './MainHeader.css'
import NavSearch from './NavSearch'
import Breadcrumb, { CrumbInfo } from '../../../components/Breadcrumb'

type Props = {
  title?: string
  breadcrumbInfo?: CrumbInfo[]
}

export function MainHeader(props: Props) {
  const { title, breadcrumbInfo } = props

  return (
    <header id="main-header">
      {breadcrumbInfo && (
        <>
          <Breadcrumb info={breadcrumbInfo} />
        </>
      )}

      {title && (
        <b>{props.title}</b>
      )}

      <NavSearch />
    </header>
  )
}
